import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { catchError, Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { Holiday } from "../models/holiday.model";

/**
 * PURPOSE: responsible for retrieve U.S. Bank Holiday information
 */
@Injectable({
  providedIn: "root"
})
export class BankHolidayService {
  constructor(private http: HttpClient) {}

  /**
   * Retrieves a List of U.S. Bank Holidays
   */
  public getBankHolidays(year: number): Observable<Holiday[]> {
    return this.http
      .get<
        Holiday[]
      >(`${environment.fulcrumUrl}/api/v3/bank-holidays/${year}`, this.buildBasicHttpOptions())
      .pipe(
        catchError((error: HttpErrorResponse): Observable<Holiday[]> => {
          if (error.status === 404) {
            console.log("Not Found");
            return of(new Array<Holiday>());
          }
          console.log(error);
          throw error;
        })
      );
  }

  private buildBasicHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(`${environment.claimItApiUsername}:${environment.claimItApiPassword}`)
      }),
      params: {}
    };
  }
}
